import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {
  anreContent,
  operatorContent,
  signatureContent,
  supplierContent,
  userContent
} from './shared/routes/content-routes';
import { ContentLayoutComponent } from './shared/layout/content-layout/content-layout.component';
import { AppAuthGuard } from './shared/guard/auth.guard';
import { PublicContentLayoutComponent } from './public/layout/content-layout/public-content-layout.component';

const routes: Routes = [
  {
    path: 'utilizator',
    component: ContentLayoutComponent,
    children: userContent,
    canActivate: [AppAuthGuard]
  },
  {
    path: 'furnizor',
    component: ContentLayoutComponent,
    children: supplierContent,
    data: {
      roles: ["supplier"]
    },
    canActivate: [AppAuthGuard]
  },
  {
    path: 'operator',
    component: ContentLayoutComponent,
    children: operatorContent,
    data: {
      roles: ["operator"]
    },
    canActivate: [AppAuthGuard]
  },
  {
    path: 'anre',
    component: ContentLayoutComponent,
    children: anreContent,
    data: {
      roles: ["anre"]
    },
    canActivate: [AppAuthGuard]
  },
  {
    path: 'semnatura',
    component: ContentLayoutComponent,
    children: signatureContent
  },
  {
    path: '',
    component: PublicContentLayoutComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'enabled',
    relativeLinkResolution: 'legacy'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
